import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "9", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.5 18h5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 22 4-11 4 11", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RadioTower";
const RadioTower = memo(themed(Icon));
export {
  RadioTower
};
//# sourceMappingURL=radio-tower.js.map
